import React from 'react';
import styled from 'styled-components';
import { Fade } from 'react-awesome-reveal';
import MapEmbed from './MapEmbed';

// --- STYLED COMPONENTS ---

const Container = styled.div`
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  max-width: 1200px;
  margin: 0 auto;
  padding: 10px 20px;
  color: #333333;
  line-height: 1.6;
`;

const MainTitle = styled.h1`
  font-size: 1.8rem;
  font-weight: 700;
  color: #439E6D; /* Deep corporate navy blue */
  text-transform: uppercase;
  letter-spacing: 0.5px;
  // margin-bottom: 25px;
`;

const SectionContainer = styled.section`
  // margin-bottom: 50px;
`;

const SectionTitle = styled.h2`
  font-size: 1.5rem;
  font-weight: 600;
  color: #439E6D;
  text-transform: uppercase;
  // margin-bottom: 20px;
  border-bottom: 2px solid #e2e8f0;
  padding-bottom: 8px;
`;

const List = styled.ol`
  list-style-type: none; /* Removing default to customize spacing */
  counter-reset: item-counter;
  padding-left: 0;
`;

const ListItem = styled.li`
  counter-increment: item-counter;
  margin-bottom: 18px;
  font-size: 1.1rem;
  display: flex;
  align-items: flex-start;
  text-align: justify;

  &::before {
    content: counter(item-counter) ". ";
    font-weight: bold;
    color: #0c2340;
    margin-right: 10px;
    flex-shrink: 0;
  }
`;

// --- MAIN COMPONENT ---

const CompanyOverview = () => {

    const address = encodeURIComponent("23 School Rd, Elelenwo, Elelenwa 500102, Rivers, Nigeria");

     const embedUrl = `https://maps.google.com/maps?q=${address}&t=&z=15&ie=UTF8&iwloc=&output=embed`;

     
  return (
    <Container>
      <Fade triggerOnce direction="up" duration={800}>
        <MainTitle>Company Overview</MainTitle>
      </Fade>

      {/* Corporate Structure Section */}
      <SectionContainer>
        <Fade triggerOnce direction="up" duration={800} delay={100}>
          <SectionTitle>Corporate Structure</SectionTitle>
        </Fade>
        <List>
          <Fade triggerOnce cascade direction="up" duration={600} fraction={0.2} damping={0.15}>
            <ListItem>
              PGSL currently has three operational divisions; Operation (Surveying, Engineering and Project Management) division, Quality-Health Safety-Environmental and Security (QHSES) division, Procurement, Finance and Administration division. Their operational structures and activities optimized in order to best serve our customer base. Although each division has a unique manager, he is at liberty to draw upon the wealth of capability throughout the organization, irrespective of divisional boundaries. This flexibility enables managers to assemble the best and most appropriate team for each client's specific requirements.
            </ListItem>
            <ListItem>
              Padec Global Services Limited (PGSL) is a Company incorporated with a vision of pulling together, Engineers, Surveyors and GIS specialist to offer consultancy and contract services to Oil and gas Companies, various tiers of Government, Corporate bodies, Industries and Individual clients.
            </ListItem>
            <ListItem>
              At PGSL, every project is subject to original observation, original approach and solutions. Our team is made of men and women with unique multi-disciplinary qualification and proven experience. The team is broad based and with its links with other firms (national and international) is capable of handling any size of project.
            </ListItem>
            <ListItem>
              The company's base of operation is in Port Harcourt and there is a liaison office in Lagos that handles logistics for projects. The Port Harcourt office is adequately equipped and manned by trained and experienced personnel.
            </ListItem>
            <ListItem>
              A salient aspect of the company's operation is health and safety of its personnel and the environment where we operate. In the light of this, PGSL places high premium on safety awareness and this is enhanced by periodic updates on health, safety and environmental manuals.
            </ListItem>
          </Fade>
        </List>
      </SectionContainer>

      {/* Corporate Objectives Section */}
      <SectionContainer>
        <Fade triggerOnce direction="up" duration={800} delay={100}>
          <SectionTitle>Corporate Objectives</SectionTitle>
        </Fade>
        <List>
          <Fade triggerOnce cascade direction="up" duration={600} fraction={0.2} damping={0.15}>
            <ListItem>
              To improve on our areas of strength and core competences by enhancing the skills and professionalism of our staff through continual training and motivation, including upgrading of facilities and infrastructures.
            </ListItem>
            <ListItem>
              To strengthen our relationship with our clients by way of effective interface in project execution with attention paid to clients' feedback.
            </ListItem>
            <ListItem>
              To explore new global market for corporate expansion and utilization of development opportunities in emerging regional markets.
            </ListItem>
            <ListItem>
              To improve the organizational structure for more robust internal processes, optimal talent utilization, mentoring and coaching for career upliftment, pleasant working environment and regular performance assessment.
            </ListItem>
            <ListItem>
              To create a well-structured Foundation for the execution of community and public give-back programmes of the company under its Corporate Social Responsibility (CSR) initiatives.
            </ListItem>
            <ListItem>
              To increase the profitability and fortune of the company for the benefit of its staff, Clients, shareholders and other stakeholders.
            </ListItem>
          </Fade>
        </List>
      </SectionContainer>
      <MapEmbed embedUrl={embedUrl}/>
    </Container>
  );
};

export default CompanyOverview;